export default "__VITE_ASSET__BcELMpCF__"